import React from "react";
import { Header } from "./Header";
import { UserList } from "./UserList";

export const Home = () => {
  return (
    <>
      <Header />
      <UserList />
    </>
  );
};
